import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    InputAdornment,
    OutlinedInput,
} from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './app/hooks';
import { Locale, selectSettings, setLocalePersistent } from './features/settings/settingsSlice';

export const LanguageSelector = () => {
    const dispatch = useAppDispatch();
    const { locale } = useAppSelector(selectSettings);

    const handleLangChange = useCallback(
        (e: SelectChangeEvent) => {
            dispatch(setLocalePersistent(e.target.value as Locale));
        },
        [dispatch]
    );

    return (
        <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="language-label" sx={{ fontSize: '0.9rem' }}>
                Language / Język / Sprache
            </InputLabel>
            <Select
                labelId="language-label"
                id="language-select"
                value={locale}
                onChange={handleLangChange}
                size='small'
                input={
                    <OutlinedInput
                        label="Language / Język / Sprache"
                        startAdornment={
                            <InputAdornment position="start">
                                <PublicIcon fontSize="small" color="primary" />
                            </InputAdornment>
                        }
                    />
                }
                sx={{
                    fontSize: '0.95rem',
                }}
            >
                <MenuItem value="en-US">English</MenuItem>
                <MenuItem value="pl">Polski</MenuItem>
                <MenuItem value="de">Deutsch</MenuItem>
            </Select>
        </FormControl>
    );
};
